module.exports = __webpack_public_path__ + "media/utomhus-entre.e28457a9.mp4";